import { render, staticRenderFns } from "./vendorLoginModal.vue?vue&type=template&id=9f745a52&scoped=true&"
import script from "./vendorLoginModal.vue?vue&type=script&lang=js&"
export * from "./vendorLoginModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f745a52",
  null
  
)

export default component.exports